<!--
category menu
AT
06.10.21
-->

<script>
	import { onMount } from 'svelte'
	import { createEventDispatcher } from 'svelte'
	import SvgSprite from '../../_shared/components/svg-sprite.svelte'

	export let parent
	export let parents
	export let categories = []

	let parentItem = window.Categories.find( {"uid":parent} )[0] || {'level':0}

	const dispatch = createEventDispatcher()

	onMount(async() => {
		categories = await window.Categories.get(parent)
	})

	function select(uid){
		dispatch('select', { parent: uid })
	}

	function deselect(uid){
		dispatch('deselect', { uid: uid })
	}

	function isSelected(uid){
		return parents.filter( el => el==uid )[0]
	}

</script>

<div class="category-menu card">
	{ #if parentItem.level > 0 }
		<a class="category-menu-close" on:click={ deselect(parent) }>✕</a>
	{ /if }
	<div class="category-menu-inner">
		<ul class="category-menu-items">
		{ #each categories as category }
			<li>
				{ #if category.categories > 0 }
					<a href="{ category.url }" class="{ isSelected(category.uid)? 'selected' : '' }" on:click|preventDefault={ select(category.uid) }>
						{ category.title }
					</a>
				{ :else }
					<a href="{ category.url }" class="{ isSelected(category.uid)? 'selected' : '' }">
						{ category.title }
					</a>
				{ /if }

				{ #if category.products }
					<a href="{ category.url }" class="category-menu-products chip">
						{ category.products }
					</a>
				{ /if }

				{ #if category.categories > 0 }
					<span class="category-menu-icon flex-end">
						<SvgSprite symbol="arrow" css="XS icon"/>
					</span>
				{ /if }
			</li>
		{ /each }
		</ul>
	</div>
</div>